import "lenis/dist/lenis.css";
import "./src/styles/global.css";
import "./src/styles/offmenu.css";
import { prepareReturnTransition } from "./src/components/case-transition";
import { enhanceCodeBlocks } from "./src/components/code-copy";
import { startDotCursor } from "./src/components/dot-cursor";
import {
  pauseSmoothScroll,
  resumeSmoothScroll,
  startSmoothScroll,
} from "./src/components/smooth-scroll";

export const onClientEntry = () => {
  startSmoothScroll();
  if (document.body) startDotCursor();
  else document.addEventListener("DOMContentLoaded", startDotCursor, { once: true });
};

/* Client-side progressive enhancements. onRouteUpdate fires after every
   Gatsby page mount — including soft navigations, where the markdown body
   arrives after hydration — and enhanceCodeBlocks is idempotent, so running
   it on every route change is safe. */
export const onRouteUpdate = () => {
  enhanceCodeBlocks();
  // Smooth scrolling is for in-page links. It stays off across a page
  // change, so the jump to the new page's top (or a restored position)
  // happens at once instead of as a visible scroll.
  // Lenis re-reads the new page once it has rendered.
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      document.documentElement.style.scrollBehavior = "";
      resumeSmoothScroll();
    })
  );
};

export const onPreRouteUpdate = ({ location, prevLocation }) => {
  // Runs while the old page is still on screen, so a case study's header
  // photo can be lifted out before the home page replaces it.
  prepareReturnTransition(location, prevLocation);
  document.documentElement.style.scrollBehavior = "auto";
  pauseSmoothScroll();
};
